<template>
  <div class="whole" flexContainer>
    <div class="left">
      <span class="text">日期范围：</span>
      <el-date-picker
        v-model="time"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      ></el-date-picker>
    </div>
    <div class="right" flexContainer>
      <div class="check checks" :class="{check_class:isCheck == 77700}" @click="check_fun(77700)">周</div>
      <div class="check" :class="{check_class:isCheck == 77701}" @click="check_fun(77701)">月</div>
    </div>
  </div>
</template>
<script>
import app from "../../../mixin/index";
export default {
  mixins: [app],
  data() {
    return {
      time: "",
      isCheck: 77700,
      //时间选择器的快捷选项
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.defaultDate();
  },
  methods: {
    check_fun(id) {
      this.isCheck = id;
    },
  }
};
</script>
<style lang="scss" scoped>
.check_class {
  color: $menu-child !important;
  background-color: $check !important;
  border: 1px solid $menu-child !important;
}
.whole {
  justify-content: space-between;
  .left {
    .text {
      @include s-c-w(14, $text-one, 400);
    }
    /deep/.el-date-editor {
      width: 240px;
      height: 32px;
      line-height: 32px;
      padding: 3px 7px;

      .el-range-input {
        @include s-c-w(14, $text-one, 400);
      }
      .el-range-separator {
        width: auto;
      }
      .el-icon-date,
      .el-range__close-icon,
      .el-range-separator {
        padding: 0;
        height: 32px;
        line-height: 32px;
        @include s-c-w(14, $text-one, 400);
      }
    }
  }
  .right {
    .check {
      cursor: pointer;
      width: 54px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background-color: $menu-color;
      border: 1px solid $border;
      @include s-c-w(14, $text-one, 400);
    }
    .checks {
      border-right: 0px solid black;
    }
  }
}
</style>